<template lang="pug">
  .section
    .page-title Demo Page
    .main(class="w-[500px]")
      .section
        string-item(:value="stringValue" @input="value => this.stringValue = value" :edit-mode="true")
        string-item(:value="stringValue" @input="value => this.stringValue = value" :edit-mode="false")
</template>
<script>
import StringItem from "@/components/ui/StringItem.vue";

export default {
  name: "DemoPage",
  components: {
    StringItem,
  },
  data() {
    return {
      stringValue: "Hello World",
      editMode: true,
    };
  },
};
</script>